var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"conference_main_box"},[(_vm.userInfoStorePopup)?_c('user-info-popup',{attrs:{"meetingID":_vm.roomId}}):_c('meetingGuard',{attrs:{"room-id":_vm.roomId,"meetingType":'public',"userInfo":_vm.userInfo}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }